/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const HOSTNAME_REGEXP = /^((([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\-]*[a-zA-Z0-9])\.)*([A-Za-z0-9]|[A-Za-z0-9][A-Za-z0-9\-]*[A-Za-z0-9]))$/;//eslint-disable-line no-useless-escape
const IP_REGEXP = /^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3})$/;
const SUBNET_MASK_REGEXP = /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])(\/([0-9]|[1-2][0-9]|3[0-2]))?$/;

export default angular.module('agrolog.validators', [])
    .directive('urlHostPort', function() {
        function validateNum(input, min, max) {
            var num = +input;
            return num >= min && num <= max && input === num.toString();
        }
        return {
                require: '?ngModel',
                link: function(scope, elm, attrs, ctrl) {
                    if (ctrl && ctrl.$validators.url) {
                        ctrl.$validators.url = function(modelValue) {
                            if (ctrl.$isEmpty(modelValue)) {
                                return true;
                            }
                            var hostPort = modelValue.split(':');
                            if (hostPort && hostPort.length == 2) {
                                var host = hostPort[0];
                                var port = hostPort[1];
                                return validateNum(port, 1, 65535) && (HOSTNAME_REGEXP.test(host) || IP_REGEXP.test(host));
                            }
                            return false;
                        };
                    }
                }
            };
    })
    .directive('urlIp', function() {
        return {
            require: '?ngModel',
            link: function(scope, elm, attrs, ctrl) {
                if (ctrl && ctrl.$validators.url) {
                    ctrl.$validators.url = function(modelValue) {
                        if (ctrl.$isEmpty(modelValue)) {
                            return true;
                        }
                        return IP_REGEXP.test(modelValue);
                    };
                }
            }
        };
    })
    .directive('urlIpHost', function() {
        return {
            require: '?ngModel',
            link: function(scope, elm, attrs, ctrl) {
                if (ctrl && ctrl.$validators.url) {
                    ctrl.$validators.url = function(modelValue) {
                        if (ctrl.$isEmpty(modelValue)) {
                            return true;
                        }
                        return IP_REGEXP.test(modelValue) || HOSTNAME_REGEXP.test(modelValue);
                    };
                }
            }
        };
    })
    .directive('urlSubnetMask', function() {
        return {
            require: '?ngModel',
            link: function(scope, elm, attrs, ctrl) {
                if (ctrl && ctrl.$validators.url) {
                    ctrl.$validators.url = function(modelValue) {
                        if (ctrl.$isEmpty(modelValue)) {
                            return true;
                        }
                        return SUBNET_MASK_REGEXP.test(modelValue);
                    };
                }
            }
        };
    })
    .name;